import React from 'react';

import * as NavConstants from 'constants/NavConstants';
import {TFIObject} from 'notebook/tfi/TFIConstants';
import * as nyc from 'ui-library/NYC';

import TFIObjectItem from './TFIObjectItem';

interface Props {
  tfiObjects?: Array<TFIObject> | null;
}

// eslint-disable-next-line react/prefer-stateless-function
class TFIObjectList extends React.Component<Props> {
  override render(): JSX.Element {
    return (
      <nyc.Row
        aria-labelledby={`${NavConstants.Section.TFI}_TAB`}
        className="u-position-relative"
        fluid={true}
        id={`${NavConstants.Section.TFI}_PANEL`}
        role="tabpanel"
      >
        {(() => {
          if (!this.props.tfiObjects) {
            return <div className="sidepanel-fadedMessage">Loading...</div>;
          }
          if (this.props.tfiObjects.length === 0) {
            return <div className="sidepanel-fadedMessage">No files found.</div>;
          }
          return (
            <nyc.Col sm={6} className="u-absolute-scroll-container">
              {this.props.tfiObjects.map((tfiObject) => (
                <TFIObjectItem key={tfiObject.id} tfiObject={tfiObject} isChild={false} />
              ))}
            </nyc.Col>
          );
        })()}
      </nyc.Row>
    );
  }
}

export default TFIObjectList;
